export default __webpack_public_path__ + "static/media/bg_red_big.ba85f1db.svg";